export default __webpack_public_path__ + "static/media/icon_email.466f47a8.svg";